export const dashboardKeys = {
    all: ['dashboard'] as const,
    fleetUtilization: () => [...dashboardKeys.all, 'fleet-utilization'] as const,
}
